import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AutoLogoutService } from './core/common/services/auto-logout.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    /**
     * Constructor
     */
    constructor(private autoLogoutService: AutoLogoutService) {

    }

    ngOnInit() {
        this.autoLogoutService.startMonitoring();
    }

    ngOnDestroy() {
        this.autoLogoutService.stopMonitoring();
    }

}
